import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { ClimateService, MapsInteractiveService, SharedService } from './../../../services';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
  selector: 'widget-records',
  templateUrl: './records.component.html',
  styleUrls: ['./records.component.scss']
})
export class RecordsComponent implements OnInit {

  constructor(
    private _climate: ClimateService,
    private _shared: SharedService,
    private _map: MapsInteractiveService,
    private cdr: ChangeDetectorRef,
    private breakpointObserver: BreakpointObserver
  ) { }

  @Input() noMain: boolean = false;

  isSmallIcons;
  loading = false;
  records;
  selectedCity;
  day;
  month;

  months = {
    1: 'января',
    2: 'февраля',
    3: 'марта',
    4: 'апреля',
    5: 'мая',
    6: 'июня',
    7: 'июля',
    8: 'августа',
    9: 'сентября',
    10: 'октября',
    11: 'ноября',
    12: 'декабря'
  }

  pipeTemp(num) {
    if (num > 0) {
      return `+${Number(num)}`;
    } else {
      return num;
    }
  }

  getRecords() {
    this.loading = true;
    let filter = {
      station: this.selectedCity.id,
    }
    this._climate.records(filter).subscribe(
      async res => {
        if (res.byCity) {
          this.records = res;
          this.loading = false;
        } else {
          this.getNearClimate(this.selectedCity.id);
        }
      },
      err => {
        this.loading = false;
        this.getNearClimate(this.selectedCity.id);
      }
    );
  }

  getNearClimate(id) {
    this.loading = true;
    this._map.getNearClimate(id).subscribe(
      async res => {
        this.selectedCity = res[0];
        this.getRecords();
        this.loading = false;
      },
      err => {
        this.loading = false;
      }
    );
  }

  ngAfterViewChecked() {
    this._shared.currentFooterHeight.subscribe(state => {
      this.isSmallIcons = this.breakpointObserver.isMatched('screen and (max-width: 1044px)');    
    });
    this.cdr.detectChanges();
  }

  ngOnInit() {
    this._shared.currentCity.subscribe(city => {
      this.selectedCity = city;
      this.getRecords();
    });
    this.day = new Date();
    this.month = new Date().getMonth()+1;
  }

}
